import { render, staticRenderFns } from "./ContactHeader.vue?vue&type=template&id=4e5ad674&scoped=true"
import script from "./ContactHeader.vue?vue&type=script&lang=js"
export * from "./ContactHeader.vue?vue&type=script&lang=js"
import style0 from "./ContactHeader.vue?vue&type=style&index=0&id=4e5ad674&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5ad674",
  null
  
)

export default component.exports